import { connect } from 'react-redux'
import { getState, getDispatch } from 'x/modules/product/PGSelectorViewConnect'
import PGSelectorView from './PGSelectorView'

export default connect(
  (state) => getState(state),
  (dispatch) => getDispatch(dispatch)
)(PGSelectorView)
